"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinutesInBatch = exports.PlaytimeBatchInfo = void 0;
const types_1 = require("../types");
class PlaytimeBatchInfo {
    constructor(activatedOffer) {
        this.activatedOffer = activatedOffer;
        if (!this.activatedOffer) {
            throw new Error('Activated offer is required for PlaytimeBatchInfo');
        }
        if (!this.activatedOffer.batchPlaytimeConfig) {
            throw new Error('Batch playtime config is required for PlaytimeBatchInfo');
        }
    }
    getBatchIndexAtTime(time) {
        return Math.floor((time.getTime() - types_1.FTimestampFunc.toMillis(this.activatedOffer.activationTimeStamp)) /
            (this.activatedOffer.batchPlaytimeConfig.minutesBetweenBatches * 60 * 1000));
    }
    getBatchStartTime(batchIndex) {
        if (batchIndex >= this.activatedOffer.batchPlaytimeConfig.batchCount) {
            return null;
        }
        return new Date(types_1.FTimestampFunc.toMillis(this.activatedOffer.activationTimeStamp) +
            batchIndex * this.activatedOffer.batchPlaytimeConfig.minutesBetweenBatches * 60 * 1000);
    }
    getBatchEndTime(batchIndex) {
        if (batchIndex >= this.activatedOffer.batchPlaytimeConfig.batchCount) {
            return null;
        }
        return new Date(types_1.FTimestampFunc.toMillis(this.activatedOffer.activationTimeStamp) +
            (batchIndex + 1) *
                this.activatedOffer.batchPlaytimeConfig.minutesBetweenBatches *
                60 *
                1000);
    }
    hasProgressInBatches(batchIndexStart, batchCount) {
        const batchIndexEnd = Math.min(this.activatedOffer.batchPlaytimeConfig.batchCount - 1, batchIndexStart + batchCount - 1);
        const minutesInBatch = this.getMinutesInBatch();
        for (let batchIndex = Math.max(0, batchIndexStart); batchIndex <= batchIndexEnd; batchIndex++) {
            const remainingMinutes = this.getRemainingMinutesInBatch(batchIndex);
            if (remainingMinutes < minutesInBatch) {
                return true;
            }
        }
        return false;
    }
    getMinutesInBatch() {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
        return (0, exports.getMinutesInBatch)((_a = this.activatedOffer) === null || _a === void 0 ? void 0 : _a.batchPlaytimeConfig);
    }
    getRemainingMinutesInBatch(batchIndex) {
        const startTime = this.getBatchStartTime(batchIndex);
        const endTime = this.getBatchEndTime(batchIndex);
        if (!startTime || !endTime) {
            return 0;
        }
        let batchInstanceCreated = false;
        let remainingMinutes = 0;
        for (const task of this.activatedOffer.tasks) {
            if (task.taskType !== types_1.TaskType.PLAYTIME) {
                continue;
            }
            if (!task.startTimestamp ||
                types_1.FTimestampFunc.toMillis(task.startTimestamp) !== startTime.getTime()) {
                continue;
            }
            if (!task.endTimestamp ||
                !endTime ||
                types_1.FTimestampFunc.toMillis(task.endTimestamp) !== endTime.getTime()) {
                continue;
            }
            batchInstanceCreated = true;
            remainingMinutes += task.amount - task.current;
        }
        if (!batchInstanceCreated) {
            return this.getMinutesInBatch();
        }
        return remainingMinutes;
    }
    getTotalRemainingPlaytimeMinutes(time) {
        const batchIndex = this.getBatchIndexAtTime(time);
        if (batchIndex >= this.activatedOffer.batchPlaytimeConfig.batchCount) {
            return 0;
        }
        const remainingFullBatches = this.activatedOffer.batchPlaytimeConfig.batchCount - batchIndex - 1;
        return (remainingFullBatches * this.getMinutesInBatch() + this.getRemainingMinutesInBatch(batchIndex));
    }
}
exports.PlaytimeBatchInfo = PlaytimeBatchInfo;
const getMinutesInBatch = (batchPlaytimeConfig) => {
    if (!batchPlaytimeConfig || !batchPlaytimeConfig.batchTasks) {
        return 0;
    }
    return batchPlaytimeConfig.batchTasks.reduce((acc, task) => {
        return acc + task.amount;
    }, 0);
};
exports.getMinutesInBatch = getMinutesInBatch;
